module.exports = __webpack_public_path__ + "img/orange_tick_mark.cc81fe7e.svg";